// Module
var code = "<problem-list-widget></problem-list-widget>";
// Exports
module.exports = code;